import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=61a780c8&scoped=true"
import script from "./newPassword.vue?vue&type=script&lang=js"
export * from "./newPassword.vue?vue&type=script&lang=js"
import style0 from "./newPassword.vue?vue&type=style&index=0&id=61a780c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a780c8",
  null
  
)

export default component.exports